import { safeJsonParse } from '../util-functions';
var defaultExtractEngineRequestResultData = function (engineRequestResultDBData) {
    return safeJsonParse(safeJsonParse(engineRequestResultDBData.resultText));
};
export var extractJobResultData = function (executionId, executionResultString, extractEngineRequestResultData) {
    var executionResults = safeJsonParse(executionResultString);
    if (executionResults) {
        var executionResultData = executionResults.find(function (r) { return r.sourceOfTheRequest === executionId; });
        return extractEngineRequestResultData
            ? extractEngineRequestResultData(executionResultData)
            : defaultExtractEngineRequestResultData(executionResultData);
    }
};
